module.exports = __webpack_public_path__ + "static/1-32e9a4cd45f9055bd6f219e9851b5467.jpg";